import React from 'react';
import {Stack, StackProps} from "@mui/material";

const AdComponent = ({...props}: StackProps) => {

    return (
        <Stack flex={1} width={"100%"} alignSelf={"center"} justifyContent={"end"} pb={2.5} pt={5} {...props}>
            <ins className="adsbygoogle"
                style={{display: "block", width: '100%', height: 80, alignSelf: 'end'}}
                data-ad-format="autorelaxed"
                data-ad-test={"on"}
                data-ad-client="ca-pub-5574510758094882"
                data-ad-slot="2717848080">
            </ins>
        </Stack>
    );
}

export default AdComponent; 